import React from 'react';
import { ShoppingBagIcon } from '@heroicons/react/24/outline';
import ReturnItemInfo from '../../actions/shared/ReturnItemInfo';

const ReturnItemsList = ({ approvedReturnItems, groupReturnReason }) => {
  return (
    <>
      {/* Return Reason */}
      {groupReturnReason && (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
          <p className="text-sm">
            <span className="font-medium">Return Reason:</span> {groupReturnReason}
          </p>
        </div>
      )}

      {/* Display items */}
      <div className="mb-6">
        <h2 className="text-lg font-medium text-gray-900 mb-3 flex items-center">
          <ShoppingBagIcon className="h-5 w-5 mr-2 text-gray-600" />
          Return Items
        </h2>
        
        <div className="space-y-4">
          {approvedReturnItems
            .filter(item => item.returnRequest || ['return_approved_by_merchant', 'return_requested_by_customer'].includes(item.status))
            .map(item => (
              <div key={item.id} className="border border-gray-200 rounded-lg bg-white p-4">
                <ReturnItemInfo 
                  item={item} 
                  statusText={item.status?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                  showReturnDetails={true}
                />
              </div>
            ))
          }
        </div>
      </div>
    </>
  );
};

export default ReturnItemsList; 